import React from 'react';
import styles from '../../styles/components/layout/Header.module.scss';
import {  useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { RootState } from '../../store/GlobalStore';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../shared/images/logoACTIVITAL2.png';
import logoWhite from '../../shared/images/logoACTIVITAL.png'; // Importez le nouveau logo
import iconLogin from '../../shared/images/Icon awesome-user-circle.svg';
import iconLoginWhite from '../../shared/images/Icon awesome-user-circle-white.svg'; // Importez l'icône blanche
import france from '../../shared/images/france.png';
import english from '../../shared/images/royaume-uni.png';
const Header: React.FC = () => {
    const { i18n } = useTranslation();
    const authState = useSelector((state: RootState) => state.Auth);
    const location = useLocation();
    const isHomePage = location.pathname === '/';
    const mode = useSelector((state: RootState) => state.Bot.mode);

     // Fonction pour changer la langue
     const toggleLanguage = () => {
        console.log(i18n.language)
        const newLang = i18n.language === "fr" ? "en" : "fr";
        i18n.changeLanguage(newLang);
        localStorage.setItem("i18nextLng", newLang); // Mémorise manuellement
      };

    return (
        <div className={`${styles.Header} ${(isHomePage && mode === 1) ? styles.transparent : ''}`}>
            <div className={styles.Left}>
                <div className={styles.Logo}>
                    <Link to='/'>
                        <img src={(isHomePage && mode === 1 )? logoWhite : logo} alt='Activital' />
                    </Link>
                </div>
            </div>
            <div className={styles.Right}>
                <button className={styles.LanguageButton} onClick={toggleLanguage}>
                <img src={i18n.language === 'fr' ? france : english} alt='langue' />
                </button>
                <div className={styles.LinksContainer}>
                    <Link to={authState.user ? '/mon-compte' : '/login'}>
                        {authState.user ? (
                            <div className={styles.Avatar}>
                                {authState.user?.firstname
                                    ? (authState.user.firstname.substring(0, 1).toUpperCase() ?? '') +
                                    (authState.user.lastname?.substring(0, 1).toUpperCase() ?? '')
                                    : (authState.user?.lastname?.substring(0, 2).toUpperCase() ?? '')
                                }
                            </div>
                        ) : (
                            <img src={(isHomePage && mode === 1) ? iconLoginWhite : iconLogin} alt='iconLogin' />
                        )}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Header;